import {useContext} from 'react';
import {Switch, Route, Redirect, useRouteMatch} from 'react-router-dom';
import {AuthContext} from '../../../../../contexts/auth/context';
import {AuthContextType} from '../../../../../contexts/auth/types';
import {ScreenPaths} from '../../../../../enums/screen-path';
import {Box} from '@mui/material';
import ActivityFeedSystemAdministratorOfficeScreen from '../activity-feed/activity-feed.system-administrator.screen';
import StatisticsSystemAdministratorOfficeScreen from '../statistics/statistics.system-administrator.screen';
import ApiDocsSystemAdministratorOfficeScreen from '../api-docs/api-docs.system-administrator.screen';
import ApplicationsSystemAdministratorOfficeScreen from '../applications/_root/applications.system-administrator.screen';
import UserCardsSystemAdministratorOfficeScreen from '../user-cards/_root/user-cards.system-administrator.screen';
import DevicesSystemAdministratorOfficeScreen from '../devices/_root/devices.system-administrator.screen';
import EntitiesSystemAdministratorOfficeScreen from '../entities/_root/entities.system-administrator.screen';
import UserCardSystemAdministratorOfficeScreen from '../user-cards/edit/user-card.system-administrator.screen';
import DeviceSystemAdministratorOfficeScreen from '../devices/edit/device.system-administrator.screen';
import EntitySystemAdministratorOfficeScreen from '../entities/edit/entity.system-administrator.screen';
import SeniorsSystemAdministratorOfficeScreen from '../seniors/_root/seniors.system-administrator.screen';
import SeniorSystemAdministratorOfficeScreen from '../seniors/edit/senior.system-administrator.screen';
import CaregiversSystemAdministratorOfficeScreen from '../caregivers/_root/caregivers.system-administrator.screen';
import CaregiverSystemAdministratorOfficeScreen from '../caregivers/edit/caregiver.system-administrator.screen';
import PlaylistsSystemAdministratorOfficeScreen from '../playlists/_root/playlists.system-adminitrator.screen';
import PlaylistSystemAdministratorOfficeScreen from '../playlists/edit/playlist.system-administrator.screen';
import GdprErasureRequestsSystemAdministratorOfficeScreen from '../gdpr-erasure-requests/_root/gdpr-erasure-requests.system-administrator.screen';

export default function SystemAdministratorOffice() {
  // Get context
  const authContext: AuthContextType = useContext(AuthContext);

  // Routing
  let {path} = useRouteMatch();

  return (
    <Box>
      <Switch>
        {/* Activity feed */}
        <Route exact path={`${path}${ScreenPaths.SystemAdministrator_Activity}`}>
          <ActivityFeedSystemAdministratorOfficeScreen />
        </Route>
        {/* Applications */}
        <Route exact path={`${path}${ScreenPaths.SystemAdministrator_Applications}`}>
          <ApplicationsSystemAdministratorOfficeScreen />
        </Route>
        {/* Entities */}
        <Route exact path={`${path}${ScreenPaths.SystemAdministrator_Entities}`}>
          <EntitiesSystemAdministratorOfficeScreen />
        </Route>
        <Route path={`${path}${ScreenPaths.SystemAdministrator_Entities}/:id`}>
          <EntitySystemAdministratorOfficeScreen />
        </Route>
        {/* Devices */}
        <Route exact path={`${path}${ScreenPaths.SystemAdministrator_Devices}`}>
          <DevicesSystemAdministratorOfficeScreen />
        </Route>
        <Route path={`${path}${ScreenPaths.SystemAdministrator_Devices}/:deviceId`}>
          <DeviceSystemAdministratorOfficeScreen />
        </Route>
        {/* Cards */}
        <Route exact path={`${path}${ScreenPaths.SystemAdministrator_UserCards}`}>
          <UserCardsSystemAdministratorOfficeScreen />
        </Route>
        <Route path={`${path}${ScreenPaths.SystemAdministrator_UserCards}/:id`}>
          <UserCardSystemAdministratorOfficeScreen />
        </Route>
        {/* API documentation */}
        <Route exact path={`${path}${ScreenPaths.SystemAdministrator_ApiDocs}`}>
          <ApiDocsSystemAdministratorOfficeScreen />
        </Route>
        {/* Statistics */}
        {authContext.state.session?.systemAdministratorProfile?.analyticsAdmin === true && (
          <Route exact path={`${path}${ScreenPaths.SystemAdministrator_Statistics}`}>
            <StatisticsSystemAdministratorOfficeScreen />
          </Route>
        )}
        {/* Seniors */}
        <Route exact path={`${path}${ScreenPaths.SystemAdministrator_Seniors}`}>
          <SeniorsSystemAdministratorOfficeScreen />
        </Route>
        <Route path={`${path}${ScreenPaths.SystemAdministrator_Seniors}/:id`}>
          <SeniorSystemAdministratorOfficeScreen />
        </Route>
        {/* Caregivers */}
        <Route exact path={`${path}${ScreenPaths.SystemAdministrator_Caregivers}`}>
          <CaregiversSystemAdministratorOfficeScreen />
        </Route>
        <Route path={`${path}${ScreenPaths.SystemAdministrator_Caregivers}/:id`}>
          <CaregiverSystemAdministratorOfficeScreen />
        </Route>
        {/* Playlists */}
        <Route exact path={`${path}${ScreenPaths.SystemAdministrator_Playlists}`}>
          <PlaylistsSystemAdministratorOfficeScreen />
        </Route>
        <Route path={`${path}${ScreenPaths.SystemAdministrator_Playlists}/:id`}>
          <PlaylistSystemAdministratorOfficeScreen />
        </Route>
        {/* GDPR Erasure Requests */}
        <Route exact path={`${path}${ScreenPaths.SystemAdministrator_GdprErasureRequests}`}>
          <GdprErasureRequestsSystemAdministratorOfficeScreen />
        </Route>

        {/** Default route */}
        <Route path={path}>
          <Redirect to={`${path}${ScreenPaths.SystemAdministrator_Activity}`} />
        </Route>
      </Switch>
    </Box>
  );
}
